<template>
  <navbar title="Vehicle Type" />
  <div class="vehicle-type">
    <div class="title">{{ $t('message.garage.addVehicleQuestion') }}</div>
    <div class="type-list">
      <div class="type-item" @click="toPage('/selectVehicleInfo?type=car')">
        <div class="type-img" name="btn_add_vehicle_car" v-track-click>
          <img :src="carImg" alt="Goods" class="responsive-image" />
        </div>
        <div class="type-desc">{{ $t('message.garage.carOrTruck') }}</div>
      </div>
      <div class="type-item" @click="toPage('/selectVehicleInfo?type=moto')">
        <div class="type-img" name="btn_add_vehicle_motorcycle" v-track-click>
          <img :src="motoImg" alt="Goods" class="responsive-image" />
        </div>
        <div class="type-desc">{{ $t('message.garage.motoOrPower') }}</div>
      </div>
    </div>
  </div>
</template>
<script setup>
import navbar from '@/components/navbar/navbar.vue'
import carImg from '@/assets/images/car/carImg.png'
import motoImg from '@/assets/images/moto/motoImg.png'
import { useRouter } from 'vue-router'
const router = useRouter()
const route = useRoute()
const toPage = (url) => {
  router.push(url)
}
</script>
<style lang="scss">
.vehicle-type {
  padding: 10px;
  padding-top: 20px;
  .title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
}
.responsive-image {
  // width: 42vw;
  width: 100%;
}
.type-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 30px;
  .type-item {
    flex: 1;
    text-align: center;
    &:active {
      .type-img {
        background-color: #e3efff;
      }
    }
    .type-img {
      padding: 8px;
      border-radius: 10px;
      background-color: #fff;
      border: 1px solid #ddd;
      height: 40vw;
      line-height: 45vw;
    }
    .type-desc {
      font-size: 16px;
      margin-top: 10px;
      font-weight: bold;
    }
  }
}
</style>
